@if ({
  isLogged: isLogged$ | async,
  }; as content) {
  @if (product.code) {
    <div class="simple-card product-row">
      <!-- <add-to-wish-list></add-to-wish-list> -->
      <div class="inner-product-row">
        <div class="box-image">
          <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl">
            <cx-media [container]="product.images?.['PRIMARY']" format="product" [alt]="product.name ?? ''"></cx-media>
          </a>
          <div class="m-b-12">
            <product-compare-check [InProduct]="product"></product-compare-check>
          </div>
        </div>
        <div class="box-content">
          <div class="details">
            <h3 class="box-product-name" [title]="product.completeName">
              @if (!product.isCustom) {
                <a
                  tabindex="0"
                  [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
                  [innerHTML]="fixProductName(product.completeName)"
                ></a>
              } @else {
                <span [innerHTML]="fixProductName(product.completeName)"></span>
              }
            </h3>
            @if (product.customerPartNumber) {
              <div class="cod w-100 m-t-20">
                <strong class="m-r-4">{{ 'intro.customer' | cxTranslate }} #:</strong> <span>{{ product.customerPartNumber }}</span>
              </div>
            }
            @if (product.partNumber) {
              <div class="cod w-100 m-t-20">
                <strong class="m-r-4">{{ 'intro.part' | cxTranslate }} #:</strong> <span>{{ product.partNumber }}</span>
              </div>
            }
            @if (product.catalogNumber) {
              <div class="catalog w-100">
                <strong class="m-r-4">{{ 'productRow.labels.catalog' | cxTranslate }} #:</strong> <span>{{ product.catalogNumber }}</span>
              </div>
            }
            @if (product.nonReturnable) {
              <div class="catalog w-100 d-flex align-items-center text-warning">
                <strong class="m-r-4">{{ 'productRow.labels.nonReturnable' | cxTranslate }}</strong>
                <tooltip-icon [content]="'cart.cartItems.nonReturnableItemWarning' | cxTranslate" />
              </div>
            }
            @if (!product.discontinued) {
              <div class="price" [attr.aria-label]="'productDetails.productPrice' | cxTranslate">
                <product-price [InProduct$]="productAsObservable()" [lazyPrice]="true"></product-price>
              </div>
            } @else {
              <span class="ff-bold m-t-20 text-danger">
                {{ 'productRow.noLonger' | cxTranslate }}
              </span>
            }
            @if (!product.discontinued) {
              @if (content.isLogged) {
                @if (product.thirdPartyPriceStatus?.hasSuccess) {
                  @if (product.yourPrice?.value !== 0) {
                    <div class="quantity">
                      <span class="label">{{ 'cart.addToCart.quantity' | cxTranslate }}</span>
                      <div class="cx-counter-stock">
                        @if (hasStock) {
                          <cx-item-counter
                            [max]="maxQuantity"
                            [control]="convertToUntypedFormControl(addToCartForm.get('quantity'))!"
                          ></cx-item-counter>
                        }
                      </div>
                    </div>
                  }
                }
              }
            }
          </div>
        </div>
        <div class="lists" *smallerThan="DEVICE_SIZE.DESKTOP">
          <collapse-list [collapseList]="keyFeatures"></collapse-list>
        </div>
        <div class="actions w-100">
          <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="btn btn-primary w-100">
            <span class="d-flex icon material-symbols-outlined m-r-4"> frame_inspect </span>
            {{ 'productRow.actions.viewDetails' | cxTranslate }}
          </a>
          @if (product.discontinued) {
            <product-replacement [product]="product"></product-replacement>
          } @else {
            @if (content.isLogged) {
              <cx-add-to-cart [inProduct$]="product2Observable()" [showQuantity]="false" [qty$]="addToCartForm.get('quantity')?.valueChanges">
              </cx-add-to-cart>
            } @else {
              <a tabindex="0" [routerLink]="['/where-to-buy']" class="btn btn-primary w-100">
                <span class="d-flex icon material-symbols-outlined m-r-4"> location_on </span>
                {{ 'productRow.actions.whereToBuy' | cxTranslate }}
              </a>
            }
          }
        </div>
      </div>
      <collapse-list *limitUp="DEVICE_SIZE.DESKTOP" [collapseList]="keyFeatures"></collapse-list>
    </div>
  }
}
